import Button from "@/components/base/Button";
import { Input } from "@/components/base/Field";
import { currentMonthRange, periodLabel, type Period } from "@/utils/period";

interface Props {
  value: Period;
  onChange: (period: Period) => void;
  /** Texte affiché à droite (ex. nombre d'opérations). */
  note?: string;
}

/** Intervalle Du / Au (bornes incluses) avec retour rapide au mois en cours. */
export default function DateRangeBar({ value, onChange, note }: Props) {
  return (
    <div className="flex flex-wrap items-end gap-3">
      <Input
        label="Du"
        type="date"
        value={value.from}
        max={value.to || undefined}
        onChange={(e) => e.target.value && onChange({ ...value, from: e.target.value })}
      />
      <Input
        label="Au"
        type="date"
        value={value.to}
        min={value.from || undefined}
        onChange={(e) => e.target.value && onChange({ ...value, to: e.target.value })}
      />
      <Button variant="outline" icon="ri-calendar-line" onClick={() => onChange(currentMonthRange())}>
        Mois en cours
      </Button>
      <p className="pb-2 text-xs text-foreground-500">
        Période : {periodLabel(value)}
        {note ? ` • ${note}` : ""}
      </p>
    </div>
  );
}
